import { render, staticRenderFns } from "./Sys_userpriv.vue?vue&type=template&id=1d7ca53a&scoped=true"
import script from "./Sys_userpriv.vue?vue&type=script&lang=js"
export * from "./Sys_userpriv.vue?vue&type=script&lang=js"
import style0 from "./Sys_userpriv.vue?vue&type=style&index=0&id=1d7ca53a&prod&scoped=true&lang=less"
import style1 from "./Sys_userpriv.vue?vue&type=style&index=1&id=1d7ca53a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ca53a",
  null
  
)

export default component.exports